import React, { useState } from "react";
import { Select, Checkbox, Typography } from "antd";
import iIcon from "../../assets/images/i-icon.png";
import InsuranceInfoModal from "./InsuranceInfoModal";
import InsuranceTermsModal from "./InsuranceTermsModal";
import insuranceImage from "../../assets/images/insurance.png";

const { Option } = Select;
const { Text, Title } = Typography;

const InsuranceSelection = ({
  insurance,
  setInsurance,
  agreedToTerms,
  setAgreedToTerms,
}) => {
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  const [termsModalOpen, setTermsModalOpen] = useState(false);

  const handleTermsClick = () => {
    setTermsModalOpen(true);
  };

  const handleTermsAccept = () => {
    setAgreedToTerms(true);
    setTermsModalOpen(false);
  };

  const handleInfoClick = () => {
    setInfoModalOpen(true);
  };

  const handleInsuranceChange = (value) => {
    setInsurance(value);
  };

  return (
    <div>
      <div
        style={{
          width: "100%",
          borderRadius: "10px",
          backgroundColor: "#FFF",
          marginTop: "15px",
          border: "1px solid #e0e0e0",
          padding: "16px",
        }}
      >
        {/* Header with Info Icon */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginBottom: "16px",
          }}
        >
          <img
            src={insuranceImage.src}
            alt="Insurance"
            style={{ width: "24px", height: "24px" }}
          />
          <Title
            level={4}
            style={{
              fontSize: "20px",
              fontWeight: 700,
              margin: 0,
            }}
          >
            AlfaMall Muhaffiz Takaful
          </Title>
          <img
            src={iIcon.src}
            alt="Info"
            onClick={handleInfoClick}
            style={{
              width: "20px",
              height: "20px",
              cursor: "pointer",
              marginLeft: "4px",
            }}
          />
        </div>

        {/* Dropdown Selection */}
        <Select
          placeholder="Takaful"
          value={insurance}
          onChange={handleInsuranceChange}
          style={{
            width: "100%",
            marginBottom: "5px",
            fontSize: "14px",
            fontFamily: "Lato",
          }}
          size="large"
        >
          <Option value="true">Takaful</Option>
          <Option value="false">No Takaful</Option>
        </Select>

        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Checkbox checked={agreedToTerms} onChange={handleTermsClick} />
          <Text style={{ fontSize: "12px", lineHeight: 1.4 }}>
            I have read and agreed to the{" "}
            <span
              style={{
                color: "#d32f2f",
                cursor: "pointer",
                textDecoration: "underline",
                fontSize: "12px",
              }}
              onClick={handleTermsClick}
            >
              Basic Fact Sheet
            </span>
          </Text>
        </div>
      </div>

      {/* Modals */}
      <InsuranceInfoModal
        open={infoModalOpen}
        onClose={() => setInfoModalOpen(false)}
      />

      <InsuranceTermsModal
        open={termsModalOpen}
        onClose={() => setTermsModalOpen(false)}
        onAccept={handleTermsAccept}
      />
    </div>
  );
};

export default InsuranceSelection;
